import WebUtils from "../../utils/WebUtils";

let baseUrl = WebUtils.getProctorBaseUrl();
let globalAdminBaseUrl = `${baseUrl}/proctor-platform/api/v1`;

export const getAllBatch = `${globalAdminBaseUrl}/b2b/candidate/batch`;
export const createBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/createBatch`;
export const addSingleCandidatetoBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/createSingleCandidate`;
export const addBulkCandidatestoBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/createBulkCandidate`;
export const getAllStudents = `${globalAdminBaseUrl}/b2b/candidate/batch/getCandidateByBatchId`;
export const getAllBulkDetails = `${globalAdminBaseUrl}/b2b/candidate/batch/getAllBulkDetails`;
export const getBulkStudents = `${globalAdminBaseUrl}/b2b/candidate/batch/getBulkCandidateData`;
export const getJobGuide = `${globalAdminBaseUrl}/b2b/candidate/batch/getJobGuideDropdownData`;
export const assignGuidesToBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/assignGuidesToBatch`;
export const assignGuideToBatches = `${globalAdminBaseUrl}/b2b/candidate/batch/assignGuideToBatches`;
export const assignGuidesToStudents = `${globalAdminBaseUrl}/b2b/candidate/batch/assignGuidesToCandidates`;
export const guideAssignedBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/guideAssignedBatches`;
export const getBatchDropdownData = `${globalAdminBaseUrl}/b2b/candidate/batch/getBatchDropdownData`;
export const getBatchAssignedCandidateData = `${globalAdminBaseUrl}/b2b/candidate/batch/getBatchAssignedCandidateData`;
export const unAssignGuideFromBatch = `${globalAdminBaseUrl}/b2b/candidate/batch/unassignGuideFromBatches`;




